



// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import io from 'socket.io-client';

// const InfluencerHeader = ({ page, getCampaigns }) => {
//   const [userdata, setuserdata] = useState([]);
//   const [notifications, setNotifications] = useState([]);
//   const [isPermissionGranted, setIsPermissionGranted] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);  // State to track mobile screen
//     const [showModal, setShowModal] = useState(false);
//   const navigate = useNavigate();

//   // Function to get influencer data
//   const getInfluencerData = () => {
//     const influencerId = localStorage.getItem("influencerID");

//     if (!influencerId) {
//       console.log("No influencer ID found in localStorage.");
//       return;
//     }

//     fetch(`https://server-side-influencer-production.up.railway.app/influencer/getInfluencer/${influencerId}`)
//       .then(response => response.json())
//       .then(data => {
//         setuserdata(data.data);
//       })
//       .catch(err => {
//         console.error("Error fetching influencer data:", err);
//       });
//   };

//   // Request permission for notifications
//   const requestNotificationPermission = () => {
//     if ('Notification' in window) {
//       Notification.requestPermission().then((permission) => {
//         setIsPermissionGranted(permission === 'granted');
//       });
//     } else {
//       console.log('Browser does not support notifications.');
//     }
//   };

//   // Show browser notification
//   const showBrowserNotification = (title, options) => {
//     if ('Notification' in window && Notification.permission === 'granted') {
//       const notification = new Notification(title, options);

//       // When the notification is clicked, navigate to the InfluencerHistory page
//       notification.onclick = () => {
//         navigate('/InfluencerHistory'); // Navigate without passing state
//       };
//     }
//   };

//   // Handle incoming campaigns
//   useEffect(() => {
//     requestNotificationPermission();
//     const socket = io('https://server-side-influencer-production.up.railway.app'); 

//     socket.on('newCampaign', (data) => {
//       setNotifications(prevNotifications => [...prevNotifications, data.message]);
//       showBrowserNotification('New Campaign Live!', {
//         body: data.message,
//         icon: '/path/to/icon.png',
//       });
//       getCampaigns(); 
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, [getCampaigns]);

//   // Fetch influencer data on mount
//   useEffect(() => {
//     getInfluencerData();
//   }, []);

//   // Track screen size and determine if it's mobile
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768); // You can adjust this value for different mobile breakpoints
//     };

//     handleResize(); // Check the screen size initially
//     window.addEventListener("resize", handleResize); // Add event listener to detect screen resize

//     return () => {
//       window.removeEventListener("resize", handleResize); // Clean up event listener
//     };
//   }, []);

//   // Close modal on outside click
//   const handleOutsideClick = (e) => {
//     if (e.target.id === 'modalOverlay') {
//       setShowModal(false);
//     }
//   };
//   return (
//     // Conditionally render the header based on screen size
//     !isMobile && (
//       <div className="h-20 flex items-center justify-between mx-auto w-full px-4 sm:px-10 border-b-2 ml-10">
//         <nav>
//           <p className="font-bold text-xl ml-12">Influencer &gt; {page}</p>
//         </nav>

//         <div className="flex items-center space-x-4">
//           {/* Profile Section */}

//             <div className="flex items-center space-x-4">
//            <div
//               onClick={() => setShowModal(true)}
//               className="flex items-center space-x-4 cursor-pointer"
//             >
//                 <img
//                   className="w-10 h-10 rounded-full"
//                   src={userdata.profilepicinfluet || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"} 
//                   alt="User Profile"
//                 />
//               </div>

//               <div className="font-medium hover:text-blue-700 cursor-pointer">
//                 <div>Hi, {userdata.fullname}</div>
//               </div>
//             </div>
    

//           {/* Notification Icon */}
//           <Link to="/notifyinflueencers" className="ml-4 flex items-center relative">
//             <div className="relative cursor-pointer">
//               <NotificationsIcon className="text-xl" />
//               {notifications.length > 0 && (
//                 <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-600 text-white text-xs rounded-full flex items-center justify-center">
//                   {notifications.length}
//                 </div>
//               )}
//             </div>
//           </Link>
//         </div>

        
//       {/* Modal with only circular image */}
//       {showModal && (
//         <div
//           id="modalOverlay"
//           onClick={handleOutsideClick}
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
//         >
//           <img
//             className="w-64 h-64 rounded-full border-4 border-white shadow-2xl object-cover"
//             src={userdata.profilepicinfluet || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
//             alt="Profile Large"
//           />
//         </div>
//       )}
//       </div>
//     )
//   );
// };

// export default InfluencerHeader;









import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import io from "socket.io-client";

const InfluencerHeader = ({ page, getCampaigns }) => {
  const [userdata, setuserdata] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [isPermissionGranted, setIsPermissionGranted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();

  const isMenuOpen = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditProfile = () => {
    handleMenuClose();
    navigate("/InfluencerProfileEdit");
  };

  const handleLogout = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(";").forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      window.open("https://smesh.in/", "_blank");
    } catch (err) {
      console.log("Error during logout:", err);
      window.open("https://smesh.in/", "_blank");
    }
  };

  const getInfluencerData = () => {
    const influencerId = localStorage.getItem("influencerID");
    if (!influencerId) {
      console.log("No influencer ID found in localStorage.");
      return;
    }
    fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${influencerId}`)
      .then((response) => response.json())
      .then((data) => {
        setuserdata(data.data);
      })
      .catch((err) => {
        console.error("Error fetching influencer data:", err);
      });
  };

  const requestNotificationPermission = () => {
    if ("Notification" in window) {
      Notification.requestPermission().then((permission) => {
        setIsPermissionGranted(permission === "granted");
      });
    } else {
      console.log("Browser does not support notifications.");
    }
  };

  const showBrowserNotification = (title, options) => {
    if ("Notification" in window && Notification.permission === "granted") {
      const notification = new Notification(title, options);
      notification.onclick = () => {
        navigate("/InfluencerHistory");
      };
    }
  };

  useEffect(() => {
    requestNotificationPermission();
    const socket = io("https://server-side-influencer.onrender.com");

    socket.on("newCampaign", (data) => {
      setNotifications((prev) => [...prev, data.message]);
      showBrowserNotification("New Campaign Live!", {
        body: data.message,
        icon: "/path/to/icon.png",
      });
      getCampaigns();
    });

    return () => {
      socket.disconnect();
    };
  }, [getCampaigns]);

  useEffect(() => {
    getInfluencerData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target.id === "modalOverlay") {
      setShowModal(false);
    }
  };

  return (
    !isMobile && (
      <div className="h-20 flex items-center justify-between mx-auto w-full px-4 sm:px-10 border-b-2 ml-12">
        <nav>
          <p className="font-bold text-xl ml-12">Influencer &gt; {page}</p>
        </nav>

        <div className="flex items-center space-x-4 mr-12">
          <div className="flex items-center space-x-4">
            <div onClick={() => setShowModal(true)} className="flex items-center space-x-4 cursor-pointer">
              <Link to="/notifyinflueencers" className="ml-4 flex items-center relative">
                <div className="relative cursor-pointer">
                  <NotificationsIcon className="text-xl ml-3" />
                  {notifications.length > 0 && (
                    <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-600 text-white text-xs rounded-full flex items-center justify-center">
                      {notifications.length}
                    </div>
                  )}
                </div>
              </Link>
              <img
                className="w-10 h-10 rounded-full ml-7"
                src={userdata.profilepicinfluet || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
                alt="User Profile"
              />
            </div>

            {/* Dropdown beside name with toggle */}
            <div
              className="flex items-center space-x-1 font-medium hover:text-blue-700 cursor-pointer"
              onClick={handleMenuClick}
            >
              <span>Hi, {userdata.fullname}</span>
              {isMenuOpen ? (
                <ArrowDropUpIcon fontSize="large" className="text-3xl" />
              ) : (
                <ArrowDropDownIcon fontSize="large" className="text-3xl" />
              )}
            </div>

            {/* Dropdown Menu beside the icon */}
            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem onClick={handleEditProfile}>
                <EditIcon className="mr-2" fontSize="small" /> Edit Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon className="mr-2" fontSize="small" /> Logout
              </MenuItem>
            </Menu>
          </div>
        </div>

        {/* Modal for large profile image */}
        {showModal && (
          <div
            id="modalOverlay"
            onClick={handleOutsideClick}
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          >
            <img
              className="w-64 h-64 rounded-full border-4 border-white shadow-2xl object-cover"
              src={userdata.profilepicinfluet || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
              alt="Profile Large"
            />
          </div>
        )}
      </div>
    )
  );
};

export default InfluencerHeader;
